import type React from 'react'
import maxSmilingIcon from '@/assets/imgs/max_smiling.png'

type ChatbotIconProps = React.ImgHTMLAttributes<HTMLImageElement>

const ChatbotIcon: React.FC<ChatbotIconProps> = (props) => {
  return (
    <img
      src={maxSmilingIcon}
      alt="Chatbot Avatar"
      width={props.width || 22}
      height={props.height || 22}
      {...props}
    />
  )
}

export default ChatbotIcon
